import { BaseCommand } from './BaseCommand';
import { goto } from '$app/navigation';

export class UserCommand extends BaseCommand {
  getKeywords() {
    return ['user'];
  }

  parameterDescriptions = [{ key: 'query', description: 'The query to search for' }];

  action() {
    goto(`/admin/user/${this.parameters[0]}`);
  }
}
